
import { colors } from "./Colors";
import { fontWeight, FontWeight } from "./Fonts";

export const theme = {
  colors: colors,
  fontWeight: fontWeight,
}
